import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ScrollVertical } from 'elements/functional/ScrollVertical';
import { motion } from 'framer-motion';
import { EColors, EGrads, EHovers } from 'libs/styles/styling';
import { useIsWide } from 'libs/utils/logic/ui/responsiveLogic';
import styled from 'styled-components/macro';

interface Props {
    content: JSX.Element;
    onClose: () => void;
}

export const ModalWrapperMini = (props: Props): JSX.Element => {
    const isWide = useIsWide();

    const animation = {
        initial: { transform: 'scale(0)' },
        animate: { transform: 'scale(1)' },
        transition: {
            delay: 0.1,
            transform: { duration: 0.3 },
            default: { ease: 'linear' }
        }
    };

    return (
        <S_Overlay onClick={props.onClose}>
            {!isWide && (
                <>
                    <S_CloseWrapper {...animation} onClick={props.onClose}>
                        <S_CloseButton icon={['fal', 'xmark']} />
                    </S_CloseWrapper>
                </>
            )}
            <S_Animation {...animation}>
                {isWide && (
                    <>
                        <S_ClosePcWrapper onClick={props.onClose}>
                            <S_CloseButton icon={['fal', 'xmark']} />
                        </S_ClosePcWrapper>
                    </>
                )}
                <S_ModalMiniContent light={true}>
                    <S_Content
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                    >
                        {props.content}
                    </S_Content>
                </S_ModalMiniContent>
            </S_Animation>
        </S_Overlay>
    );
};

const S_Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    z-index: 1001;
    @media only screen and (min-width: 1260px) {
        padding: 20px;
    }
`;

const S_Animation = styled(motion.div)`
    width: 100%;
    max-width: 400px;
    height: 450px;
    max-height: 90%;
    position: relative;
`;

const S_ModalMiniContent = styled(ScrollVertical)`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    border-radius: 7px;
    box-shadow: 5px 5px 15px rgb(0 0 0 / 20%);
    background-color: #f1f1f1;
`;

const S_Content = styled.div`
    position: relative;
`;

const S_CloseWrapper = styled(motion.div)`
    top: 10px;
    right: 10px;
    position: fixed;
    z-index: 2000001;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    color: ${EColors.DARK};
    background: ${EGrads.ACC1_GRAD};
    box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &:hover {
        box-shadow: ${EHovers.LIGHT2}, 0px 10px 30px rgba(0, 0, 0, 0.3);
    }
`;

const S_ClosePcWrapper = styled(S_CloseWrapper)`
    position: absolute;
    right: 0px;
    top: -55px;
`;

const S_CloseButton = styled(FontAwesomeIcon)`
    font-size: 18px;
    padding: 5px;
    display: flex;
`;
